import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { AssessementContext } from "../../AssessmentContext";
import { useContext } from "react";
import { api } from "../../../../../api";
import { useMutation } from "react-query";
import { useDispatch } from "react-redux";
import ScaleLoader_ from "../../components/ScaleLoader";
import toast from "react-hot-toast";
import { useCustomToast } from "../../../../../components/customtoast/CustomToastProvider";
import { exams } from "../../../../../api/exams";
import { updateAnswers } from "../view-assessement/components/UpcomingAssessment";
import { useSelector } from "react-redux";
import { exams as examsApi } from "../../../../../api/exams";
import { toPlainAnwers } from "../candidate-assessment/components/utils/functions";
import { decryptQuestionResponse } from "../candidate-assessment/components/utils/decryptData";
import { useTranslation } from "react-i18next";
import { v4 } from 'uuid';
const Instructions = ({ start, restart }) => {

  const { assessment, setAssessment } = useContext(AssessementContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {t} = useTranslation()
  const customToast = useCustomToast();
  const user = JSON.parse(sessionStorage.getItem('user'))
  const time_left = parseInt(window.sessionStorage.getItem("time_left"));
  const duration = parseInt(window.sessionStorage.getItem("duration"));
  const currentLanguage = useSelector((state) => state.traslation.language);
  const last_question_viewed = parseInt(
    sessionStorage.getItem("last_question_viewed")
  );
  const time_in_minutes = (time) => Math.floor(time / 60);
const { questionSavedAnswers, questionsDuration, examQuestions } =
    useSelector((state) => state.candidateExam);

  const unsupportedActions = [
    t('minimize-browser'),
    t('resize-browser'),
    t('open-new-tab'),
    t('open-new-program'),
    t('ctrl-c'),
    t('ctrl-v'),
    t('print-screen'),
    t('f12'),
  ];

  const updateAnswersMutation = useMutation(examsApi.updateAnswersv2, {
      onSuccess: (response) => {
        dispatch(flushSubmittedAnswers());
        refetch();
      },
    });

  const getQuestionsmutation = useMutation(exams.getExamQuestionsv2, {
    onSuccess: async (data) => {
    const encryptedData = data?.data?.encryptedData; // From encryptData.encryptedData
    const ivHex = data?.data?.iv; // From encryptData.iv
    const secretKeyHex = process.env.REACT_APP_ENCRYPTION_KEY; 
    //const response = await decryptQuestionResponse({ encryptedData, ivHex, secretKeyHex,})
    const questionResponse = data?.data?.questions?.length ? 
      data?.data?.questions?.map( q => {
         if(q?.type === "single correct"){
           return {...q, type: 'select'}
         }
         if(q?.type === 'free text'){
           return {...q, answers: q?.answers?.length ? q?.answers :
             [{answer_id: `null_${v4()}`, text: '', status: false}] }
         } else return q;
      } )
    : [] 
    console.log("questionResponse", questionResponse);
    
    if(sessionStorage.getItem("rejoinUser") === '1'){
      sessionStorage.setItem("rejoinUser", '0')
   //compare between current question and prevoius saved questions
       
   const questions = questionResponse?.filter((q) => {
          return q?.answers?.some((ans) => ans?.status === true);
        });
        if (examQuestions?.length) {
          if (questions?.length === 0) {
            //sync client answers
            const client_answers = toPlainAnwers(examQuestions);
             updateAnswers({
              answers: client_answers, questionsDuration,
              questions: questionResponse, updateAnswersMutation
            });
          } else {
            //check for unsync questions and retry submitting
            const client_answers = toPlainAnwers(examQuestions);
            const server_answers = toPlainAnwers(questions);
            const unsynced_answers = client_answers.filter((client_answer) => {
              return !server_answers.some((server_answer) => {
                return (
                  client_answer.question_id === server_answer.question_id &&
                  client_answer.answer_id === server_answer.answer_id
                );
              });
            });
            //update answers
            if (unsynced_answers?.length){
               updateAnswers({
                answers: unsynced_answers, questionsDuration,
                questions: questionResponse, updateAnswersMutation
              });
            }
          }
        }
    return
    }
    else {
    if(!questionResponse?.length){
      toast.error(t('error-no-question'))
    }
    else{
    setAssessment({
      ...assessment,
      assessements: { questions: questionResponse },
      activeQuestion: { ...questionResponse[0] },
      questionType: questionResponse[0]?.type,
      activeAssessment: {
        ...JSON.parse(window.sessionStorage.getItem("active-assessment")),
      },
    });
    setTimeout(
      () => navigate("/candidate/assessments/candidate-assessment"),
      100
    );
    }
    }
    },
    onError: ({ response }) => {
      toast.remove();
      customToast.error(response?.data?.message);
    },
  });

  React.useEffect(() => {
    const container = document.querySelector(`#parent-container`);
    container.scrollTo({ top: 0 });
    sessionStorage.setItem("exam-submit-status", 0);
    sessionStorage.setItem("device-width", window.innerWidth);
    sessionStorage.setItem("device-height", window.innerHeight);
    setAssessment({ ...assessment, isAutomove: false });
    // validate and sync if user is coming from rejoin page
    if(sessionStorage.getItem("rejoinUser") === '1'){
        getQuestionsmutation.mutate({
        userId: user?.user?.user_id || window.sessionStorage.getItem("user_id"),
        examId: window.sessionStorage.getItem("active-assessment-id"), 
        userExamId: window.sessionStorage.getItem("active-assessment-user-id"),
        showOnlyQuestions: true,
        language: currentLanguage,
        number_of_attempts : (sessionStorage.getItem("loginType") === 'join' || sessionStorage.getItem("fromRoute") === 'result') ? 
          parseInt(sessionStorage.getItem('attempt_count'))
        : JSON.parse(window.sessionStorage.getItem("active-assessment"))?.current_attempt,
        //level: sessionStorage.getItem("level") || 'easy',
        //switchQuestion: true
      });
    };
  }, []);

  const startAssessment = () => {
    if (time_left !== duration && time_left !== null && !isNaN(time_left)) {
      if (time_left === 0) {
        restart(new Date().getTime() + time_left * 60 * 1000);
      } else restart(new Date().getTime() + time_left * 60 * 1000);
    } else {
      restart(new Date().getTime() + duration * 60 * 1000);
    }

    setAssessment({ ...assessment, startAssessment: true });
    sessionStorage.setItem("full_screen_mode", 1);
    const element = document.documentElement; // Get the root element of the document
    if (element.requestFullscreen) {
      element.requestFullscreen();
    }
    //hide sidebar and
    // setIsOpen(false)
    document.querySelector("#sidebar").style.display = "none";
    //hide navbar in mobile devices
    if (window.matchMedia("(max-width: 700px)").matches) {
      document.querySelector(".mobile-navbar").style.display = "none";
    }
    setTimeout(() => {
      getQuestionsmutation.mutate({
        userId: user?.user?.user_id || window.sessionStorage.getItem("user_id"),
        examId: window.sessionStorage.getItem("active-assessment-id"), 
        userExamId: window.sessionStorage.getItem("active-assessment-user-id"),
        showOnlyQuestions: false,
        language: currentLanguage,
        number_of_attempts : (sessionStorage.getItem("loginType") === 'join' || sessionStorage.getItem("fromRoute") === 'result') ? 
          parseInt(sessionStorage.getItem('attempt_count'))
        : JSON.parse(window.sessionStorage.getItem("active-assessment"))?.current_attempt,
       // level: sessionStorage.getItem("level") || 'easy',
       // switchQuestion: true
      });
    }, 1000);
  };

  const brandedClient = JSON.parse(sessionStorage.getItem("client") || '{}');

  return (
    <div>
      {" "}
      {getQuestionsmutation?.isLoading ? <ScaleLoader_ /> : null}
      <section className="jumbotron bg-white p-4">
        {
          //<Link
        //   to={"/candidate/assessments/view-assessments"}
        //   className="text-lg"
        // >
        //   {t('exam')}
        // </Link>
        // <span className="mx-2">/</span>
        // <Link
        //   to={"/candidate/assessments/instructions"}
        //   className="text-lg text-customGreen"
        // >
        //   {t('instructions')}
        // </Link>
        }
        <div style={{ backgroundColor: brandedClient?.primary_colour || undefined}} className="mt-8 py-12 bg-darkBlue px-5 text-white rounded-lg">
          <h5 className="text-2xl flex">
            {
               assessment?.activeAssessment?.assessment_title
              || JSON.parse(window.sessionStorage.getItem("active-assessment"))?.title
            }
          </h5>
          <p className="text-[12px]">{t('attempt-all-questions')}</p>
          <div className="mt-4 bg-white py-4 rounded-lg text-gray-900 px-4 flex justify-between">
            <span>
              {t('total-questions')}{" "}
              {sessionStorage.getItem("ql")}
            </span>
            <span className="text-xl flex items-center">
              <i className="text-2xl bi bi-clock-history mr-2"></i>{" "}
               {duration}
              {t('minutes')}
            </span>
          </div>
        </div>
        <div className="mt-5">
          <h5 className="text-2xl">
            {" "}
            <strong className="text-2xl">{t('instructions')}:</strong>{" "}
          </h5>
          <h4 className="text-lg text-red-500">
            {t('read-instructions')}
          </h4>
          <p className="mt-3 text-lg">
            {t('full-screen')}
          </p>
          <p className="mt-3 text-lg">
            1.&nbsp; {t('frozen-screen')} {t('recommendation')}
          </p>
          <p className="mt-3 text-lg">
            2. &nbsp;  {t('screen-not-sized')} {t('resize-or-switch')}
          </p>
          <p className="mt-3 text-lg">
            3. &nbsp;  {t('assessment-timer')}
          </p>
          <p className="mt-3 text-lg">
            4. &nbsp;  {t('optimal-experience')}
          </p>
          <p className="mt-3 text-lg">
            5. &nbsp;  {t('flag-question')}
          </p>
          <p className="mt-3 text-lg">
            6. &nbsp; {t('unusual-activities')}
          </p>
          <h4 className="text-2xl text-red-500 mt-5">
            {t('secure-assessment-advice')}
          </h4>
          <p className="mt-1 text-lg">
             {t('secure-assessment-warning')}
          </p>
          <strong className="text-xl block my-3">
             {t('unsupported-actions')}:
          </strong>
          <ul className="py-5 px-3 bg-red-100 border border-red-500 rounded-lg">
            {unsupportedActions.map((unsupportedAction, id) => {
              return (
                <li
                  key={id}
                  className="mt-3 text-lg capitalize text-red-500 flex items-center"
                >
                  <span className="text-xl bi bi-exclamation-triangle ml-3 mr-2"></span>
                  {unsupportedAction}
                </li>
              );
            })}
          </ul>
          <div className="mt-8 flex justify-end mb-5">
            <button
              onClick={startAssessment}
              disabled={getQuestionsmutation.isLoading}
              className="border flex justify-center bg-red-500 text-white py-3 block  w-[300px] rounded-lg"
            >
              <span
                className="text-lg text-center"
                data-testid="assessment-instruction"
              >
                {" "}
                {t('ok-understand')}{" "}
              </span>
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Instructions;
